import { AppState } from './app.state';

export const appInitialState: AppState = {
  showTreatmentPlanDialog: false,
  treatmentPlanData: {},
};
